import React, { ChangeEvent } from 'react';

import './SelectInput.scss';

export interface SelectOption {
  // eslint-disable-next-line react/no-unused-prop-types
  optionValue: string;
  // eslint-disable-next-line react/no-unused-prop-types
  optionText: string;
}

interface Props {
  options: SelectOption[];
  label: string;
  onChange: (v: string) => void;
  error?: string;
  value: string | null;
}

const SelectInput = ({
  options,
  label,
  onChange,
  error,
  value,
}: Props): React.ReactElement => {
  const classNames = [
    'select-input',
    error ? 'has-error' : undefined,
  ];

  const handleChange = (event: ChangeEvent) => {
    const selectInput = event.target as HTMLSelectElement;
    onChange(selectInput.value);
  };

  return (
    <div className={classNames.join(' ')}>
      <div className="label">
        {label}
      </div>

      <div className="select-wrapper">
        <select className="input" onChange={handleChange} value={value || undefined}>
          {options.map(({ optionValue, optionText }: SelectOption) => (
            <option
              value={optionValue}
              label={optionText}
              key={optionValue}
            >
              {optionText}
            </option>
          ))}
        </select>
      </div>

      {error && (
        <div className="form-field-error">
          {error}
        </div>
      )}
    </div>
  );
};

export default SelectInput;
